<template>
    <div>
        <ui-modal v-if="isOpen" ref="editContactModal" class="contact-modal" :title="contact.id > 0 ? 'Edit Contact' : 'New Contact'" @hide="reset" dismiss-on="close-button esc">
            <div class="container-fluid" style="padding: 0; margin-top: 1rem;">
                <div class="row">
                    <div class="col-6">
                        <ui-select
                            label="Title"
                            :options="ContactTitles"
                            v-model="contact.title"
                            @input="unsetEmpty"
                        ></ui-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <ui-textbox label="First Name" v-model="contact.first_name" @keydown="guessCapsLockState"></ui-textbox>
                    </div>
                    <div class="col-6">
                        <ui-textbox label="Last Name" v-model="contact.last_name" @keydown="guessCapsLockState"></ui-textbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <ui-textbox label="Company Name" v-model="contact.company_name" @keydown="guessCapsLockState"></ui-textbox>
                    </div>
                </div>

                <div class="row" style="margin-top: 1rem;">
                    <div class="col-6">
                        <referral-source-picker
                            label="Referral Source" 
                            v-model="contact.referral_source"
                            :invalid="hasInvalidReferralSource"
                        ></referral-source-picker>
                    </div>
                    <div class="col-6">
                        <ui-select
                            label="Contact Type"
                            :options="ContactTypeList"
                            v-model="contactTypeProxy"
                            :invalid="hasInvalidType"
                        ></ui-select>
                    </div>
                </div>

                <!-- Contact Details !-->
                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Contact Details</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <ui-textbox label="Email" v-model="contact.email"></ui-textbox>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <ui-textbox label="Primary Telephone" v-model="contact.primary_telephone"></ui-textbox>
                    </div>
                    <div class="col-6">
                        <ui-textbox label="Alternate Telephone" v-model="contact.alternate_telephone"></ui-textbox>
                    </div>
                </div>

                <!-- Other Details !-->
                <div class="row">
                    <div class="col">
                        <div class="meta-container">
                            <h6 style="font-weight: normal;">Marketing Preferences &amp; Consent</h6>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!-- Marketing Opt-In !-->
                    <div class="col">
                        <ui-switch 
                        label="Telephone"
                         v-model="contact.telephone_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>
                    <div class="col">
                        <ui-switch 
                        label="Email"
                         v-model="contact.email_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>

                    <div class="col">
                        <ui-switch 
                        label="SMS"
                         v-model="contact.sms_marketing" 
                         style="margin-bottom: 0; z-index:2;"
                        ></ui-switch>
                    </div>
                </div>
            </div>

                <!-- Address !-->
                <div class="row" style="margin-top: 1rem;">
                    <div class="col">
                        <div class="meta-container">
                            <h5>Address</h5>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <address-selector label="" v-model="addressProxy"></address-selector>
                    </div>
                </div>

            <div slot="footer" style="width: 100%; text-align: right;">
                <ui-progress-circular v-show="isLoading" style="float:left;"></ui-progress-circular>
                <button :disabled="isLoading" class="btn btn-primary" @click="save">Save</button>
            </div>
        </ui-modal>

        <!-- Duplicates !-->
        <similar-contact-modal
            ref="duplicates"
        ></similar-contact-modal>
    </div>
</template>

<script>
    import { ContactSchema, ContactTypeList, ContactTitles, ReferralSourceResource, ContactResource } from '../../classes/Api/Contact.js';
    import AddressSelector from './controls/KeenAddress'
    import ReferralSourcePicker from './controls/KeenReferralSourcePicker' 
    import { mapState, mapActions } from 'vuex';
    import SimilarContactModal from "../elements/SimilarContactModal";

    export default {
        components: {SimilarContactModal, AddressSelector, ReferralSourcePicker },
        data() {
            return {
                ContactTypeList,
                ContactTitles,
                contact: new ContactSchema(),
                isLoading: false,
                isCapsOn: false,
                isOpen: false,
            }
        },
        watch: {
            contact: {
                handler: _.debounce(function(n,o) {
                    if (n.first_name) {
                        if (this.isCapsOn) {
                            this.contact.first_name = this.contact.first_name.toLowerCase()
                        }

                        this.contact.first_name = this.contact.first_name.replace(/\s[a-z]/g, function(letter) {
                            return letter.toUpperCase();
                        });
                    }

                    if (n.last_name) {
                        if (this.isCapsOn) {
                            this.contact.last_name = this.contact.last_name.toLowerCase()
                        }

                        this.contact.last_name = this.contact.last_name.replace(/\s[a-z]/g, function(letter) {
                            return letter.toUpperCase();
                        });
                    }

                    if (n.company_name) {
                        if (this.isCapsOn) {
                            this.contact.company_name = this.contact.company_name.toLowerCase()
                        }

                        this.contact.company_name = this.contact.company_name.replace(/\s[a-z]/g, function(letter) {
                            return letter.toUpperCase();
                        });
                    }
                }, 100),
                deep: true
            }
        },
        methods: {
            unsetEmpty(val) {
                if (typeof val === 'string' && val.length === 0) {
                    this.contact.title = null
                }
            },
            guessCapsLockState(e) {
                if (e.getModifierState('CapsLock')) {
                    this.isCapsOn = true
                } else {
                    this.isCapsOn = false
                }
            },
            ...mapActions({ 'storeOrUpdate': 'contact/storeOrUpdate' }),
            reset() {
                this.isOpen = false

                this.contact = new ContactSchema();
            },
            open(defaults = {}) {
                this.isOpen = true

                this.$nextTick(() => {
                    this.contact = Object.assign(
                        {}, this.contact, defaults, window.marque.ui.contact_attribute_defaults
                    );

                    setTimeout(() => {
                        this.$el.querySelector('.ui-modal__body').scrollTop = 0;
                    }, 75)

                    this.$refs['editContactModal'].open();
                })
            },
            save() {
                this.isLoading = true;

                let contact = Object.assign({}, this.contact);

                if (contact.referral_source) {
                    contact.referral_source_id = contact.referral_source.id;
                }
                
                if (typeof this.contact.title !== 'string' && this.contact.title !== null) {
                    contact.title = contact.title.value;
                }

                if (contact.id) {
                    this.finishSave(contact)
                    return
                }

                // If this is a new contact, we check whether the data given matches any existing contacts,
                // if it matches we offer them as suggestions, otherwise we just proceed with the save.
                this.$refs.duplicates.check(contact).then(contact => {
                    this.finishSave(contact)
                }).finally(() => {
                    this.isLoading = false
                })
            },
            finishSave(contact) {
                this.storeOrUpdate(contact).then(contact => {
                    // @deprecated use saved
                    this.$emit('success', contact);
                    this.$emit('saved', contact);
                    this.isLoading = false;
                    this.$refs['editContactModal'].close();
                }, e => {
                    this.isLoading = false;
                });
            },
            onSave(callback) {
                if (callback) {
                    this.$once('saved', callback)
                }
            }
        },
        computed: {
            ...mapState({ 'storeContact': state => state.contact.current }),
            contactTypeProxy: {
                get() {
                    if (this.contact.type) {
                        return ContactTypeList.find(
                            item => item.value === this.contact.type
                        )
                    }

                    return ''
                },
                set(value) {
                    this.contact.type = value.value
                }
            },
            hasInvalidType() {
                return !this.contact.type
            },
            hasInvalidReferralSource() {
                return !this.contact.referral_source || !this.contact.referral_source.id
            },
            addressProxy: {
                get() {
                    return {
                        address_1: this.contact.address_1,
                        address_2: this.contact.address_2,
                        address_3: this.contact.address_3,
                        town: this.contact.town,
                        county: this.contact.county,
                        post_code: this.contact.post_code,
                        country: this.contact.country,
                    }
                },
                set(address) {
                    this.contact.address_1 = address.address_1;
                    this.contact.address_2 = address.address_2;
                    this.contact.address_3 = address.address_3;
                    this.contact.town = address.town;
                    this.contact.county = address.county;
                    this.contact.post_code = address.post_code;
                    this.contact.country = address.country;
                }
            }
        }
    }
</script>